
const Linker = ({children}) => {
  const reg = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi
  const linkify = (text) => {
    const newtext = text.replace(reg, (match) => {
      if(match.startsWith("http")) {
        return  `<a href="${match}" target="_blank">${match}</a>`
      }
      else {
        const url = `http://${match}`
        return `<a href="${url}" target="_blank">${match}</a>`
      }
    })

    return newtext 
  }

  const content = linkify(children);
  return (
    <span dangerouslySetInnerHTML={{__html: content }} /> 
  )
}

export default Linker
